import React from 'react';
import { ErrorPage } from '~common/components/core/error-page.component';

export const NotFound: React.FunctionComponent = () => (
  <ErrorPage title={'404'} subtitle={'This page could not be found.'} />
);



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/common/src/components/core/not-found.component.tsx